const getters = {
    API_KEYS: ({ apiKeys }) => apiKeys,
    DELETE_API_KEY_LOADING: ({ deleteApiKeyLoading }) => deleteApiKeyLoading,
    GENERATE_API_KEY_LOADING: ({ generateApiKeyLoading }) => generateApiKeyLoading,
    GET_API_KEYS_LOADING: ({ getApiKeysLoading }) => getApiKeysLoading,
    TWILIO_CHANNEL_INFO: ({ twilioChannelInfo }) => twilioChannelInfo,
    TWILIO_CHANNEL_INFO_LOADING: ({ twilioChannelInfoLoading }) => twilioChannelInfoLoading,
    UPDATE_TWILIO_CHANNEL_INFO_LOADING: ({ updateTwilioChannelInfoLoading }) => updateTwilioChannelInfoLoading,

    INCOMING_EVENT_CHANNEL_INFO: ({ incomingEventChannelInfo }) => incomingEventChannelInfo,
    INCOMING_EVENT_INFO_LOADING: ({ incomingEventChannelInfoLoading }) => incomingEventChannelInfoLoading,
    UPDATE_INCOMING_EVENT_CHANNEL_INFO_LOADING: ({ updateIncomingEventChannelInfoLoading }) => updateIncomingEventChannelInfoLoading,

    PODIUM_CHANNEL_INFO: ({ podiumChannelInfo }) => podiumChannelInfo,
    PODIUM_INFO_LOADING: ({ podiumChannelInfoLoading }) => podiumChannelInfoLoading,
    UPDATE_PODIUM_CHANNEL_INFO_LOADING: ({ updatePodiumChannelInfoLoading }) => updatePodiumChannelInfoLoading,
};

export default getters;
